<template>
  <q-field :error="errors.has('salutation')" :error-label="errors.first('salutation')">
    <q-select
      :value="value"
      @input="handleUpdate"
      v-validate.disable="'included:mr,ms'"
      data-vv-name="salutation"
      name="salutation"
      :options="salutationOptions"
      :display-value="salutationDisplayValue"
    />
  </q-field>
</template>

<script>
  export default {
    inject: ['$validator'],

    computed: {
      salutationOptions () {
        return [
          { label: this.$t('ms'), value: 'ms' },
          { label: this.$t('mr'), value: 'mr' }
        ]
      },

      salutationDisplayValue () {
        return this.value ? this.$t(this.value) : this.$t('salutation')
      }
    },

    props: {
      value: {
        type: String,
        required: false
      }
    },

    methods: {
      handleUpdate (value) {
        this.$emit('input', value)
      }
    }
  }
</script>
